import { Register } from './router'

const EmployeeModule = () => {
	const employee = require(/* webpackChunkName: "employee" */ '../modules/private/employee')
	Register('employee', employee)
	return employee
}

const AdminUpdateClientInfoModule = () => {
	const adminupdateclientinfo = require(/* webpackChunkName: "adminupdateclientinfo" */ '../modules/private/employee/update-client-info')
	Register('updateClientInfo', adminupdateclientinfo)
	return adminupdateclientinfo
}

const AdminClientSearchModule = () => {
	const adminclientsearch = require(/* webpackChunkName: "adminclientsearch" */ '../modules/private/employee/client-search')
	Register('adminClientSearch', adminclientsearch)
	return adminclientsearch
}

const AdminUserSearchModule = () => {
	const adminusersearch = require(/* webpackChunkName: "adminusersearch" */ '../modules/private/employee/user-search')
	Register('adminUserSearch', adminusersearch)
	return adminusersearch
}

const AdminUserManagementModule = () => {
	const adminusermanagement = require(/* webpackChunkName: "adminusermanagement" */ '../modules/private/employee/user-management')
	Register('adminUserManagement', adminusermanagement)
	return adminusermanagement
}

const AdminCreatePointsModule = () => {
	const admincreatepoints = require(/* webpackChunkName: "admincreatepoints" */ '../modules/private/employee/create-points')
	Register('adminCreatePoints', admincreatepoints)
	return admincreatepoints
}

const AdminMovePointsModule = () => {
	const adminmovepoints = require(/* webpackChunkName: "adminmovepoints" */ '../modules/private/employee/move-points')
	Register('adminMovePoints', adminmovepoints)
	return adminmovepoints
}

const AdminClientsReportModule = () => {
	const adminclientsreport = require(/* webpackChunkName: "adminclientsreport" */ '../modules/private/employee/reports/clients')
	Register('adminClientsReport', adminclientsreport)
	return adminclientsreport
}

const AdminPointsExtractReportModule = () => {
	const adminpointsextractreport = require(/* webpackChunkName: "adminpointsextractreport" */ '../modules/private/employee/reports/points-extract')
	Register('adminPointsExtractReport', adminpointsextractreport)
	return adminpointsextractreport
}

const AdminSalesRevenueReportModule = () => {
	const adminsalesrevenueextractreport = require(/* webpackChunkName: "adminsalesrevenueextractreport" */ '../modules/private/employee/reports/sales-revenue')
	Register('adminSalesRevenueExtractReport', adminsalesrevenueextractreport)
	return adminsalesrevenueextractreport
}

const AdminInvoicesReportModule = () => {
	const admininvoicesreport = require(/* webpackChunkName: "admininvoicesreport" */ '../modules/private/employee/reports/invoices')
	Register('adminInvoicesReport', admininvoicesreport)
	return admininvoicesreport
}

const AdminClubReportModule = () => {
	const adminclubreport = require(/* webpackChunkName: "adminclubreport" */ '../modules/private/employee/reports/club')
	Register('adminClubReport', adminclubreport)
	return adminclubreport
}

const AdminPointsBreakageReportModule = () => {
	const adminPointsBreakageReport = require(/* webpackChunkName: "adminPointsBreakageReport" */ '../modules/private/employee/reports/points-breakage')
	Register('adminPointsBreakageReport', adminPointsBreakageReport)
	return adminPointsBreakageReport
}

const AdminCardProposalsReportModule = () => {
	const adminCardProposalsReportModule = require(/* webpackChunkName: "adminCardProposalsReportModule" */ '../modules/private/employee/reports/card-proposals')
	Register('adminPointsBreakageReport', adminCardProposalsReportModule)
	return adminCardProposalsReportModule
}

const AdminCouponSearchModule = () => {
	const adminCouponSearch = require(/* webpackChunkName: "adminCouponSearch" */ '../modules/private/employee/coupon/pages/search')
	Register('adminCouponSearch', adminCouponSearch)
	return adminCouponSearch
}

const AdminCouponCreationModule = () => {
	const adminCouponCreation = require(/* webpackChunkName: "adminCouponCreation" */ '../modules/private/employee/coupon/pages/creation')
	Register('adminCouponCreation', adminCouponCreation)
	return adminCouponCreation
}

const AdminCouponDetailsModule = () => {
	const adminCouponDetails = require(/* webpackChunkName: "adminCouponDetails" */ '../modules/private/employee/coupon/pages/details')
	Register('adminCouponDetails', adminCouponDetails)
	return adminCouponDetails
}

const AdminStoreProductSearchModule = () => {
	const storeProductSearch = require(/* webpackChunkName: "storeProductSearch" */ '../modules/private/employee/store-product/pages/search')
	Register('storeProductSearch', storeProductSearch)
	return storeProductSearch
}

const AdminStoreProductCreateModule = () => {
	const storeProductCreate = require(/* webpackChunkName: "storeProductCreate" */ '../modules/private/employee/store-product/pages/create')
	Register('storeProductCreate', storeProductCreate)
	return storeProductCreate
}

const AdminStoreProductEditModule = () => {
	const storeProductEdit = require(/* webpackChunkName: "storeProductEdit" */ '../modules/private/employee/store-product/pages/edit')
	Register('storeProductEdit', storeProductEdit)
	return storeProductEdit
}

export {
	EmployeeModule,
	AdminClientSearchModule,
	AdminUserSearchModule,
	AdminUserManagementModule,
	AdminUpdateClientInfoModule,
	AdminCreatePointsModule,
	AdminMovePointsModule,
	AdminClientsReportModule,
	AdminSalesRevenueReportModule,
	AdminPointsExtractReportModule,
	AdminClubReportModule,
	AdminPointsBreakageReportModule,
	AdminCardProposalsReportModule,
	AdminCouponSearchModule,
	AdminCouponCreationModule,
	AdminCouponDetailsModule,
	AdminStoreProductSearchModule,
	AdminStoreProductCreateModule,
	AdminStoreProductEditModule,
	AdminInvoicesReportModule
}
